enum Paths {
    adminUserCreate = '/users/admin/create',
    adminUser = '/users/admin',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/AdminUser/paths.ts